import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Card from "../../../components/ui/card";
import { Switch } from "../../../components/ui/switch";
import { Laptop, Smartphone, SquareCheckBig } from "lucide-react";
import Button from "../../../components/ui/Button";
import { Badge } from "../../../components/ui/badge";


const SecurityComponent = () => {
    const { t } = useTranslation();
    const [userSecurity, setUserSecurity] = useState(null);
    const [settings, setSettings] = useState({
        security: {
            twoFactorEnabled: true,
            loginNotifications: true,
            devices: [
                {
                    id: 1,
                    name: "MacBook Pro",
                    lastActive: "2 hours ago",
                    location: "London, UK",
                    current: true
                },
                {
                    id: 2,
                    name: "iPhone 13",
                    lastActive: "5 mins ago",
                    location: "London, UK",
                    current: true
                }
            ]
        }
    });
    function handlePrivacySubmit(): void {
        throw new Error("Function not implemented.");
    }

    return <>
        <Card className="p-6" style={{ textAlign: "left" }}>
            <h2 className="text-xl font-semibold mb-6">{t("securitySettings.title")}</h2>
            <div className="space-y-6">
                {/* Two-Factor Authentication */}
                <div className="flex items-center justify-between">
                    <div>
                        <h3 className="font-medium">{t("securitySettings.twoFactorAuth")}</h3>
                        <p className="text-sm text-gray-500">
                            {t("securitySettings.twoFactorAuthDesc")}
                        </p>
                    </div>
                    <Switch
                        checked={settings.security.twoFactorEnabled}
                        onCheckedChange={(checked) => setSettings(prev => ({
                            ...prev,
                            security: { ...prev.security, twoFactorEnabled: checked }
                        }))}
                    />
                </div>

                {/* Login Notifications */}
                <div className="flex items-center justify-between">
                    <div>
                        <h3 className="font-medium">{t("securitySettings.loginNotifications")}</h3>
                        <p className="text-sm text-gray-500">
                            {t("securitySettings.loginNotificationsDesc")}
                        </p>
                    </div>
                    <Switch
                        checked={settings.security.loginNotifications}
                        onCheckedChange={(checked) => setSettings(prev => ({
                            ...prev,
                            security: { ...prev.security, loginNotifications: checked }
                        }))}
                    />
                </div>

                {/* Active Sessions */}
                <div className="border-t pt-6" style={{ textAlign: "left" }}>
                    <h3 className="font-medium mb-4">{t("securitySettings.activeSessions")}</h3>
                    <div className="space-y-4">
                        {settings.security.devices.map(device => (
                            <div key={device.id} className="flex items-center justify-between bg-gray-50 p-4 rounded-lg">
                                <div className="flex items-center gap-4">
                                    {device.name.includes("iPhone") ? (
                                        <Smartphone className="h-5 w-5 text-gray-500" />
                                    ) : (
                                        <Laptop className="h-5 w-5 text-gray-500" />
                                    )}
                                    <div>
                                        <div className="font-medium">{device.name}</div>
                                        <div className="text-sm text-gray-500">
                                            {device.location} • {device.lastActive}
                                        </div>
                                    </div>
                                </div>
                                {!device.current && (
                                    <Button variant="outline" size="sm">
                                        {t("securitySettings.revokeAccess")}
                                    </Button>
                                )}
                                {device.current && (
                                    <Badge variant={undefined} className="bg-green-50 text-green-700">
                                        {t("securitySettings.currentDevice")}
                                    </Badge>
                                )}
                            </div>
                        ))}
                    </div>
                </div>

                {/* Change Password Button */}
                <div className="border-t pt-6">
                    <Button 
                        className="w-full bg-white text-black border border-gray-300 hover:bg-gray-50"
                        variant="outline"
                    >
                        {t("securitySettings.changePassword")}
                    </Button>
                </div>
            </div>
        </Card>
        <div className="flex justify-end mt-4">
            {userSecurity == null ? (
                <button
                    className="px-4 py-2 text-white rounded-md flex items-center
      bg-blue-600 hover:bg-blue-700"
                    onClick={handlePrivacySubmit}>
                    <SquareCheckBig className="h-5" />
                    <span className="pl-2">{t("securitySettings.saveChanges")}</span>
                </button>
            ) : (
                <button
                    className={"px-4 py-2 text-white rounded-md flex items-center bg-blue-600 hover:bg-blue-700"}
                    onClick={handlePrivacySubmit}>
                    <SquareCheckBig className="h-5" />
                    <span className="pl-2">{t("securitySettings.updateChanges")}</span>
                </button>
            )}
        </div>
    </>;
};

export default SecurityComponent;